import {
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { OnInit, OnDestroy } from '@angular/core';
import { UlaPdfComponent } from '@app/shared/ula-pdf/ula-pdf.component';
import { bodyScroll } from '../../utils/utils';

export type UlaTooltipType = 'simple'|'basic'|'document'|'wizardy';
export type SmokeType = 'white'|'grey';
export type ContentHeight = 'normal'|'tallest';

@Component({
  selector: 'ula-modal',
  templateUrl: 'ula-modal.component.html',
  styleUrls: [
    './ula-modal-sizing.component.scss',
    './ula-modal.component.scss'
  ],
  providers: [
    DatePipe
  ]
})
export class UlaModalComponent implements OnInit, OnDestroy {
  @Input() type: UlaTooltipType = 'simple';
  @Input() title: string = null;
  @Input() subtitle: string = null;
  @Input() updated: Date | string = null;
  @Input() urgentText: string = null;

  @Input() showCta = false;
  @Input() showHelpful = false;
  @Input() showPrint = false;
  @Input() mustScroll = false;
  @Input() hideHeader = false;
  @Input() hideFooter = false;
  @Input() clickOutsideToClose = true;

  @Input() smokeColor: SmokeType = 'white';
  @Input() heightContent: ContentHeight = 'normal';

  @Output() hasScrolled: EventEmitter<any> = new EventEmitter();
  @Output() helpful: EventEmitter<any> = new EventEmitter();
  @Output() closed: EventEmitter<null> = new EventEmitter();

  @ViewChild('content') content: ElementRef;

  @ContentChild(UlaPdfComponent) pdfComponent: UlaPdfComponent;

  private canClose = true;
  public isVisible = false;

  constructor(private el: ElementRef, private datePipe: DatePipe) { }

  ngOnInit(): void {
    // weird render error that a [class.xxx] or ngClass on HTML
    // cause the query selector in scroll tracker to error
    if (this.heightContent === 'tallest') {
      this.content.nativeElement.classList.add('tallest');
    }
  }
  ngOnDestroy(): void {
    this.backgroundCanScroll = true;
  }

  private set backgroundCanScroll(canScroll: boolean) {
    bodyScroll(canScroll);
  }

  public get date(): string {
    if (this.updated instanceof Date) {
      return this.datePipe.transform(this.updated, 'MMMM d, y');
    } else {
      return this.updated;
    }
  }

  open(): void {
    this.isVisible = true;
    this.backgroundCanScroll = false;
  }

  public smokescreenClick(event: Event): void {
    if (this.clickOutsideToClose) {
      this.close(event);
    }
  }

  close(event: Event): void {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }

    if (this.mustScroll && !this.canClose) {
      return;
    }

    this.isVisible = false;
    this.backgroundCanScroll = true;
    this.closed.emit();
  }

  stopPropagation(event?: Event): boolean {
    if (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    return false;
  }

  private print(): void {
    if (this.pdfComponent) {
      this.pdfComponent.print();
      return;
    }

    const content: HTMLElement = this.content.nativeElement.cloneNode(true);
    const printout: Window = window.open('', 'PRINT');

    printout.document.title = this.title;
    printout.document.body.style.textAlign = 'center';
    printout.document.body.style.fontFamily = 'sans-serif';
    printout.document.body.appendChild(content);

    printout.focus();
    printout.print();
    printout.close();
  }
}
